module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-1-Social-Static-Ad.4ec4c1ba.webp";